import {
  checkRegEx,
  checkForEmpty,
  checkStartWithZero,
} from "../../../helpers/checkers"
import { regexes } from "../../../helpers/regex"

export const handleAutoNumberOfBetsBlur = (
  // setNumberOfBets: any,
  handleAutoInputs: any,
  autoPilotNumber: string,
  key: string,
  value: string
) => {
  // reset bet count on number of bets change
  handleAutoInputs(autoPilotNumber, 'betCount', 0)
  if (checkForEmpty(value)) {
    return handleAutoInputs(autoPilotNumber, key, "0"), handleAutoInputs(autoPilotNumber, 'numberOfBets', "0")
  }

  if (checkStartWithZero(value)) {
    return handleAutoInputs(autoPilotNumber, key, "0"), handleAutoInputs(autoPilotNumber, 'numberOfBets', "0")
  }

  return handleAutoInputs(autoPilotNumber, key, value), handleAutoInputs(autoPilotNumber, 'numberOfBets', value)
}

export const handleNumbersOfBetsChange = (e: any, handleAutoInputs: any, autoPilotNumber: any) => {
  const value = e.target.value
  if (checkRegEx(value, regexes.everyNumber)) {
    handleAutoInputs(autoPilotNumber, "numberOfBets", value.replace(/,/g, "."))
  }
}
